// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"maincontent_mainContent__3ZZQf","rotated":"maincontent_rotated__36DYE","page":"maincontent_page__1DT_5"};